module.exports = {
  CONTACT: "40b52faf-f5c7-48b7-9ed7-b44143438a98"
};
